module.exports = __webpack_public_path__ + "static/assets/0fd2dcc8182df84fb5b080080df2a6d5.svg";